import StickyNoteContainer from './StickyNoteContainer';
import addUserNote from '../actions/addUserNote';
import removeUserNote from '../actions/removeUserNote';
import { POPUP_GAPSPACE } from '../utils/constants';
import getDirectionalHint from '../utils/getDirectionalHint';
import getValidStickyNote, { ValidStickyNote } from '../utils/getValidStickyNote';
import { observer } from 'mobx-react-lite';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { ClientItem } from 'owa-mail-store';
import React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./UserNotePopup.scss');

interface UserNotePopupProps {
    target: IPoint | HTMLElement;
    selectedText: string;
    element: HTMLElement;
    item: ClientItem;
    isExistingUserNote: boolean;
    selectionInstance: number;
    stickyNote: ValidStickyNote;
}

let noteDiv: HTMLDivElement = null;

const UserNotePopup = observer(function UserNotePopup(props: UserNotePopupProps) {
    const {
        target,
        selectedText,
        element,
        item,
        isExistingUserNote,
        selectionInstance,
        stickyNote,
    } = props;

    const onSaveNote = () => {
        addUserNote(
            element,
            item,
            selectedText,
            selectionInstance,
            isExistingUserNote,
            stickyNote.remoteId
        );
        destroyNotePopupDiv();
    };

    const onDeleteNote = () => {
        removeUserNote(element, item, selectedText, selectionInstance, stickyNote.remoteId);
        destroyNotePopupDiv();
    };

    const onDismissNote = () => {
        destroyNotePopupDiv();
    };

    return (
        <Callout
            gapSpace={POPUP_GAPSPACE}
            className={styles.userNoteCalloutStyles}
            isBeakVisible={false}
            directionalHint={getDirectionalHint(selectedText)}
            target={target}
            onDismiss={onDismissNote}>
            <StickyNoteContainer
                noteId={stickyNote.id}
                color={stickyNote.color}
                onSaveNote={onSaveNote}
                onDeleteNote={onDeleteNote}
            />
        </Callout>
    );
});

function createNotePopupDiv() {
    noteDiv = document.createElement('div');
    document.body.appendChild(noteDiv);
}

function destroyNotePopupDiv() {
    if (noteDiv) {
        noteDiv.parentNode?.removeChild(noteDiv);
        ReactDOM.unmountComponentAtNode(noteDiv);
        noteDiv = null;
    }
}

export default async function showUserNote(
    target: IPoint | HTMLElement,
    selectedText: string,
    element: HTMLElement,
    item: ClientItem,
    isExistingUserNote: boolean,
    selectionInstance: number
) {
    if (!noteDiv) {
        createNotePopupDiv();
    }

    const stickyNote = await getValidStickyNote(
        isExistingUserNote,
        selectedText,
        selectionInstance,
        item
    );
    if (stickyNote) {
        // TODO: No-op if there is no sticky note object
        // Should this be indicated to the user? (VSO80755)
        ReactDOM.render(
            <React.StrictMode>
                <UserNotePopup
                    target={target}
                    selectedText={selectedText}
                    element={element}
                    item={item}
                    isExistingUserNote={isExistingUserNote}
                    selectionInstance={selectionInstance}
                    stickyNote={stickyNote}
                />
            </React.StrictMode>,
            noteDiv
        );
    }
}
